import type { ComponentProps } from 'react';
import React, { useCallback, useState } from 'react';

import { Spinner } from '../../../spinner/Spinner.component';
import styles from '../styles.module.css';
import type { WalletMeta } from '../types';

type Props = ComponentProps<'button'> & {
  meta: WalletMeta;
  isDisabled?: boolean;
  onConnect: () => Promise<void>;
};

export const WalletButton = ({
  onConnect,
  meta,
  className,
  isDisabled,
  ...props
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = useCallback(async () => {
    setIsLoading(true);

    await onConnect();

    setIsLoading(false);
  }, [onConnect]);

  const buttonCn = `${styles.walletButton} ${
    styles[className as keyof typeof styles]
  }`;

  return (
    <button
      className={buttonCn}
      {...props}
      onClick={handleClick}
      disabled={isLoading || isDisabled}
    >
      <span>{meta.name}</span>
      {isLoading ? (
        <div className={styles.spinnerContainer}>
          <Spinner />
        </div>
      ) : (
        <img
          src={meta.icon}
          className={styles.walletIcon}
          draggable={false}
          alt=""
        />
      )}
    </button>
  );
};
